<template>
  <div style="display: flex; flex-direction: column">
    <div class="btn">
      <el-button
        v-if="canAdd"
        type="primary"
        @click="_modify(null)"
      >新增</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        style="height: 100%"
      >
        <el-table-column prop="fName" label="职称名称" />
        <el-table-column prop="fCreater" label="创建人" />
        <el-table-column
          prop="fCreateTime"
          label="创建时间"
          :formatter="dateFormat"
        />
        <el-table-column prop="fModify" label="最后修改人" />
        <el-table-column
          prop="fModifyTime"
          label="最后修改时间"
          :formatter="dateFormat"
        />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button
                type="text"
                size="small"
                @click="_modify(scope.row)"
              >查看</el-button>
            </template>
            <template>
              <ConfirmButton
                v-if="canDel"
                @confirm="_delete(scope.row)"
              >删除</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import EditForm from './EditForm'
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    EditForm,
    ConfirmButton
  },
  data() {
    return {
      tableData: [],
      loading: false,
      currentEditItem: null,
      canAdd: true,
      canEdit: true,
      canDel: true
    }
  },
  mounted() {
    this.refresh()

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '001003002') {
        this.canAdd = val.isGrant
      }
      if (val.key == '001003003') {
        this.canEdit = val.isGrant
      }
      if (val.key == '001003004') {
        this.canDel = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('SystemApplication/Title/TitleEntry', {})
        .then((res) => {
          // console.log(res, "res");
          this.tableData = res.datalist
        })
        .finally(() => (this.loading = false))
    },
    _modify(row) {
      const isNew = !row
      this.currentEditItem = isNew ? {} : Object.assign({}, row)
      let or
      if (isNew) {
        or = this.canAdd
      } else {
        or = this.canEdit
      }
      this.$formDlg({
        title: isNew ? '新建用户职称' : `查看用户职称`,
        width: '30%',
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(isNew ? 0 : 1, formData),
        readonly: !or
      })
    },
    _delete(row) {
      this.postData(2, row)
    },
    postData(modifyType, data) {
      return this.$httpPost('SystemApplication/Title/TitleModify', {
        datalist: JSON.stringify({
          modifyType: modifyType,
          info: data
        })
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
